module.exports = __webpack_public_path__ + "static/img/ranking_all_reward_kuang_r.6c3a049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_all_reward_kuang_r.png
// module id = Nr1/
// module chunks = 0